export default __webpack_public_path__ + "static/media/somethingwrong-4.8842cbe2.png";